"use client";

/**
 * Fires `seo_page_view` once on mount with non-sensitive page context
 * (source_page / page_type / competitor). Separate from <TrackView> because the
 * funnel's TrackView intentionally carries no props; SEO pages want segmentation.
 * No-op + never throws when PostHog isn't initialized.
 */
import * as React from "react";
import posthog from "posthog-js";
import type { SeoPageType } from "@/lib/analytics/events";

export function SeoPageView({
  sourcePage,
  pageType,
  competitor,
}: {
  sourcePage: string;
  pageType: SeoPageType;
  competitor?: string;
}) {
  React.useEffect(() => {
    try {
      posthog.capture("seo_page_view", {
        source_page: sourcePage,
        page_type: pageType,
        competitor,
      });
    } catch {
      /* analytics must never break the page */
    }
    // Fire exactly once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
